import { createIcon } from "@chakra-ui/react";

export const Moonlight = createIcon({
  displayName: "Moonlight",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m13.401.224 2.016.54 1.934.833 1.615 1.353 1.517 1.46.978 1.864.996 1.847.43 2.06.092 2.092-.29 2.064-.365 2.078-.863 1.94-1.304 1.672-1.57 1.405-1.82 1.02-1.802 1.083-2.09.22-1.873.245v-.054l1.919-1.972 1.43-2.261 1.141-2.413.592-2.6.289-2.647-.048-2.684-.911-2.523-.994-2.458-1.537-2.158-1.7-2.19L11.18 0 13.4.224zM7.51 11.677l.03.876.312.818.34.797.516.695.58.72.576-.722.507-.705.356-.794.229-.841.064-.871-.29-1.719-.388-.784-.493-.721-.626-.664-.63.66-.459.746-.362.793-.18.851-.082.865z"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.184 9.92-.874.067-.804.348-.78.374-.674.546-.692.61.745.545.726.476.809.322.85.19.873.027 1.705-.364.766-.421.7-.524.635-.654-.687-.602-.764-.425-.808-.328-.859-.143-.867-.044zM1.999 5.167l.013.397.142.372.154.362.235.317.264.326.261-.328.231-.32.162-.36.104-.383.029-.396-.132-.781-.176-.357-.224-.327-.285-.302-.286.3-.209.339-.164.36-.083.387L2 5.167z"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m2.76 4.368-.398.03-.365.159-.355.17-.306.248-.315.277.339.248.33.216.367.146.387.087.397.012.775-.165.348-.192.318-.238.289-.297-.313-.274-.347-.193-.367-.149-.39-.065-.395-.02zM3.445 18.183l.013.398.142.372.155.362.234.316.264.327.262-.328.23-.32.162-.361.104-.383.03-.395-.133-.782-.176-.356-.224-.328-.284-.301-.287.3-.208.338-.165.36-.082.388-.037.393z"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="m4.205 17.384-.397.031-.365.158-.355.17-.306.248-.315.278.34.247.33.217.367.146.386.087.397.012.775-.166.348-.191.318-.238.289-.298-.312-.273-.348-.193-.367-.15-.39-.065-.395-.02z"
    />
  ],
  defaultProps: {
    "aria-label": "Moonlight icon: A moon with 3 stars"
  }
});

export default Moonlight;
